import App from './App';
// import HomeContainer from './home/containers/HomeContainer';

export const routes = {
    path: '/',
    component: App,
    indexRoute: {
        component: require('./payment/containers/Payment')
    },
    childRoutes: [
      
    ]
}


/** WEBPACK FOOTER **
 ** ./src/Routes.js
 **/